import React from 'react';

import Content from './Layout/Content';
import MobileMenu from './Layout/MobileMenu';
import Sidenav from './Layout/Sidenav';
import Topbar from './Layout/Topbar';

const Layout: React.FC = () => {
  return (
    <>
      <div className="h-full min-h-screen flex overflow-hidden bg-gray-100">
        {/* Off-canvas menu for mobile, show/hide based on off-canvas menu state. */}
        <MobileMenu />
        {/* Static sidebar for desktop */}
        <Sidenav />
        <div className="flex flex-col w-0 flex-1 overflow-hidden">
          <Topbar />
          <Content />
        </div>
      </div>
    </>
  );
};

export default Layout;
